import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyTasksDisabledState = lazy(() => import('./svg-components/tasks-disabled-state'));

const TasksDisabledState = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyTasksDisabledState {...rest} />
  </Suspense>
);

export default TasksDisabledState;
